export default {
  "app.dashboard.analysis.timeLabel": "时间",
  "component.globalHeader.notification": "通知",
  "component.globalHeader.notification.empty": "您已查看所有通知",
  "component.globalHeader.message": "消息",
  "component.globalHeader.message.empty": "您已读完所有消息",
  "component.globalHeader.event": "待办",
  "component.globalHeader.event.empty": "您已完成所有待办",
  "component.globalHeader.warn": "预警",
  "component.globalHeader.warn.empty": "您已读完所有设备预警",
  "component.noticeIcon.clear": "清空",
  "component.noticeIcon.cleared": "清空了",
  "component.noticeIcon.empty": "暂无数据",
  "component.noticeIcon.view-more": "查看更多",
  "app.device.summary.listLabel": "产品列表",
  "DeviceList.deviceid": "设备编号",
  "DeviceList.battery": "电量",
  "DeviceList.signal": "信号",
  "DeviceList.step": "步数",
  "DeviceList.distance": "距离(米)",
  "DeviceList.calorie": "卡路里(卡)",
  "DeviceList.model": "设备型号",
  "DeviceList.clientid": "客户编号",
  "DeviceList.viewdata": "查看",
  "DeviceList.group.mesage": "群发消息",
  "DeviceList.action": "操作",
  "User.logout": "退出登陆",
  "DeviceSummary.baseinfo": "基本信息",
  "DeviceSummary.watchname": "4G健康手表",
  "DeviceSummary.blewatchname": "蓝牙健康手表",
  "DeviceSummary.deviceinfo": "设备信息",
  "DeviceSummary.datasync": "一键上传",
  "DeviceSummary.summary": "概况",
  "DeviceSummary.hr": "心率",
  "DeviceSummary.rri": "房颤",
  "DeviceSummary.ecg": "心电",
  "DeviceSummary.sport": "运动",
  "DeviceSummary.sleep": "睡眠",
  "DeviceSummary.gnss": "位置",
  "DeviceSummary.male": "男",
  "DeviceSummary.female": "女",
  "DeviceSummary.gender": "性别",
  "DeviceSummary.height": "身高",
  "DeviceSummary.no": "无",
  "DeviceSummary.weight": "体重",
  "DeviceSummary.birthday": "出生日期",
  "DeviceSummary.imei": "设备号码",
  "DeviceSummary.online": "在线",
  "DeviceSummary.offline": "离线",
  "DeviceSummary.edit": "修改",
  "DeviceSummary.nickname": "昵称",
  "DeviceSummary.target.step": "目标步数",
  "DeviceSummary.target.calorie": "目标卡路里",
  "DeviceSummary.save": "保存",
  "DeviceSummary.cancel": "取消",
  "DeviceSummary.nickname.input": "请输入昵称",
  "DeviceSummary.gender.input": "请选择性别",
  "DeviceSummary.height.input": "请输入身高",
  "DeviceSummary.weight.input": "请输入体重",
  "DeviceSummary.birthday.input": "请输入生日",
  "DeviceSummary.target_step.input": "请输入目标步数",
  "DeviceSummary.target_calorie.input": "请输入目标卡路里",
  "DeviceSummary.resetdevice": "恢复出厂",
  "DeviceSummary.resetdevice.notice":
    "设备的佩戴者信息将被删除, 设备恢复到出厂模式, 你确定吗?",
  "DeviceSummary.binded": "已绑定",
  "DeviceSummary.day": "天",
  "DeviceSummary.wear": "佩戴",
  "IwownAi.aislogan": "我是微软聊天机器人,你可以问我问题",
  "IwownAi.aifailed": "哎呀，超出我的理解能力...",
  "IwownAi.hint": "请输入您的问题...",
  "IwownAi.send": "发送",
  "HealthHome.pagetitle": "数据概况",
  "HealthHome.hr": "心率",
  "HealthHome.rri": "房颤",
  "HealthHome.step": "步数",
  "HealthHome.sleep": "睡眠",
  "HealthHome.ecg": "心电",
  "HealthHome.position": "位置",
  "HealthHome.hours": "小时",
  "HealthHome.minutes": "分钟",
  "HeartRate.abnormal": "异常心率",
  "HeartRate.avghr": "平均心率",
  "HeartRate.maxhr": "最大心率",
  "HeartRate.minhr": "最小心率",
  "HeartRate.avgsporthr": "平均运动心率",
  "HeartRate.sporthr": "运动心率",
  "HeartRate.minutes": "分钟",
  "HeartRate.range_normal": "常规",
  "HeartRate.range_warmup": "热身",
  "HeartRate.range_burnfat": "燃脂",
  "HeartRate.range_aerobic": "有氧",
  "HeartRate.range_anaerobic": "无氧",
  "HeartRate.range_extreme": "极限",
  "AtrialData.afdata": "心脏健康",
  "AtrialData.today24hours": "当天24小时",
  "AtrialData.dateselect": "选择日期",
  "AtrialData.diagnosis": "诊断结论",
  "AtrialData.disclaimer": "注：非医疗诊断，供参考，请以医院确诊结论为准。",
  "AtrialData.chart_title": "散点图",
  "AtrialData.nodata": "没有房颤数据",
  "AtrialData.normal": "暂时没有检测到房颤. ",
  "AtrialData.abnormal": "疑似房颤. ",
  "AtrialData.noresult": "无结果,有干扰或者数据异常. ",
  "AtrialData.SINUS_HR": "窦性心率. ",
  "AtrialData.SINUS_BRADYCARDIA": "窦性心率过缓. ",
  "AtrialData.SINUS_TACHYCARDIA": "窦性心率过速. ",
  "AtrialData.SINUS_ARRHYTHMIA": "心率不齐(早搏). ",
  "AtrialData.SINUS_ATRIAL_FIBRILLATION": "心率不齐(房颤). ",
  "AtrialData.SINUS_SUPRAVENTRICULAR_TACHYCARDIA": "心率过速(室上性心动过速). ",
  "AtrialData.timebar_title": "最近24小时房颤分钟数/小时",
  "AtrialData.hrbar_title": "最近24小时心率曲线",
  "AtrialData.afchart_title": "最近7天 疑似房颤时长/当天有效测量时长",
  "AtrialData.measure_time": "测试时间",
  "AtrialData.aftime": "房颤时间",
  "AtrialData.time": "时间",
  "AtrialData.scatter.desc":
    "散点图: 基于⾮线性混沌理论,依靠计算机快速运算技术,对⻓程RR间期数据进⾏图形表达,⽤于⼼率变异",
  "EcgView.title": "心电",
  "EcgView.ecgdatalist": "心电数据列表",
  "EcgView.normal": "正常",
  "EcgView.SINUS.HR": "窦性心律",
  "EcgView.SINUS.BRADYCARDIA": "疑似窦性心律过缓",
  "EcgView.SINUS.TACHYCARDIA": "疑似窦性心律过速",
  "EcgView.SINUS.ARRHYTHMIA": "疑似窦性心律不齐(早搏)",
  "EcgView.SINUS.ATRIAL.FIBRILLATION": "疑似窦性心律不齐(房颤)",
  "EcgView.SINUS.NOResult": "AI无法分析出结果",
  "EcgView.loading": "正在加载数据...",
  "EcgView.note": "用户备注",
  "EcgView.diagnosis": "诊断结论",
  "EcgView.disclaimer":
    "注：以上诊断由人工智能诊断算法Cardiolearn给出，供参考，请以医院确诊结论为准。",
  "EcgView.today": "今日",
  "EcgView.sevenday": "最近7天",
  "EcgView.onemonth": "最近30天",
  "EcgView.ecgtime": "测量时间",
  "EcgView.ai_result": "分析结果",
  "Sports.title": "运动",
  "Sports.step": "步",
  "Sports.meter": "米",
  "Sports.minute": "分钟",
  "Sports.unit": "单位",
  "Sports.datalist": "运动数据列表",
  "Sports.step.title": "运动步数",
  "Sports.distance.title": "运动里程",
  "Sports.duration.title": "运动时长",
  "Sports.startime.title": "开始时间",
  "Sports.sportype.title": "运动类型",
  "Sleep.title": "睡眠",
  "Sleep.hour": "小时",
  "Sleep.minute": "分钟",
  "Sleep.score": "分",
  "Sleep.bless": "请保持好的睡眠习惯哦!",
  "Sleep.light": "浅睡",
  "Sleep.deep": "深睡",
  "Sleep.awake": "清醒",
  "Sleep.rem": "快速眼动",
  "Sleep.benchmark": "参考值:10%-40%",
  "Sleep.score.prefix": "您的睡眠得分是",
  "Sleep.value.high": "偏高",
  "Sleep.value.low": "偏低",
  "Sleep.value.normal": "正常",
  "Sleep.light_desc":
    "浅睡眠称轻度睡眠阶段，约占整个睡眠时间65%。本阶段睡眠属浅睡或轻度至中度睡眠状态，睡眠者已不易被唤醒，此时肌肉进一步放松，脑电图显示梭状睡眠波。",
  "Sleep.deep_desc":
    "深度睡眠又称为“黄金睡眠”，约占整个睡眠时间25%。 大脑皮层细胞处于充分休息状态，有助于消除疲劳、恢复精力、免疫抗病。",
  "Sleep.awake_desc":
    "合理的睡眠应该是每晚7~9小时，这是睡眠质量的保证。保持良好的睡眠习惯，遵循睡眠的自然规律，是减少睡眠清醒的最好办法。",
  "Sleep.rem_desc":
    "快速眼动又称为快速动眼睡眠，是正常睡眠周期中的一个阶段，在这个阶段中眼球会快速的向各个方向移动，同时身体的肌肉会放松，呈现一种临时性瘫痪的状态。",
  "Auth.Login.failed.title": "登录失败",
  "Auth.Login.failed.desc": "请检查你的账号和密码",
  "Auth.site.desc": "Watch Center 是微软4G手表的数据展示平台",
  "Auth.username": "用户名",
  "Auth.username.prompt": "请输入用户名!",
  "Auth.password": "密码",
  "Auth.password.prompt": "请输入密码!",
  "Auth.autologin": "自动登录",
  "Auth.login": "登录",
  "Auth.login.method.account": "账户密码登录",
  "OverView.listview.title": "设备编号",
  "Menu.dashboard": "仪表盘",
  "Menu.Monitor": "监控页",
  "Menu.Robot": "机器人",
  "Menu.Device": "设备",
  "Menu.DeviceList": "设备列表",
  "DeviceSetting.Setting": "设备设置",
  "DeviceSetting.Notification.Title": "好消息",
  "common.save.succeed": "保存信息成功",
  "common.save.failed": "保存信息失败",
  "Export.button.name": "导出",
  "Export.Base.title": "基本信息",
  "Export.Base.nickname": "用户昵称",
  "Export.Base.deviceId": "设备ID",
  "Export.Base.date": "日期",
  "Export.Base.details": "详细数据",
  "Export.Base.times": "时间",
  "Export.Sleep.title": "睡眠小结",
  "Export.Sleep.total": "睡眠总时长",
  "Export.Sleep.start": "入睡时间",
  "Export.Sleep.end": "起床时间",
  "Export.Sleep.deep": "深睡时长",
  "Export.Sleep.light": "浅睡时长",
  "Export.Sleep.rem": "REM时长",
  "Export.Sleep.wake": "清醒时长",
  "Export.Sleep.cycle": "周期",
  "Export.Sleep.duration": "时长",
  "Export.Heart.hr": "心率",
  "Export.Step.step": "步数",
};
